var _path, _path2, _path3, _path4, _path5, _rect, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0002 13.5C1.0002 6.56448 6.42821 1 13.0538 1C19.6794 1 25.1074 6.56448 25.1074 13.5C25.1074 20.4355 19.6794 26 13.0538 26C6.42822 26 1.0002 20.4355 1.0002 13.5Z",
    stroke: "#A3A3A3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57617 12.8154C8.57617 11.987 9.24774 11.3154 10.0762 11.3154L16.0762 11.3154C16.9046 11.3154 17.5762 11.987 17.5762 12.8154L17.5762 18.8154C17.5762 19.6439 16.9046 20.3154 16.0762 20.3154L10.0762 20.3154C9.24774 20.3154 8.57617 19.6439 8.57617 18.8154L8.57617 12.8154Z",
    fill: "#C4C4C4",
    stroke: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5765 15.3152C14.5765 16.138 13.9272 16.805 13.1261 16.805C12.3251 16.805 11.6757 16.138 11.6757 15.3152C11.6757 14.4924 12.3251 13.8254 13.1261 13.8254C13.9272 13.8254 14.5765 14.4924 14.5765 15.3152Z",
    fill: "#A3A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.01 16.8086C14.01 17.3572 13.5771 17.8019 13.0431 17.8019C12.5091 17.8019 12.0762 17.3572 12.0762 16.8086C12.0762 16.2601 12.5091 15.8154 13.0431 15.8154C13.5771 15.8154 14.01 16.2601 14.01 16.8086Z",
    fill: "#A3A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.576 10.8153C10.576 9.49103 10.3227 6.95239 13.1882 6.95239C16.0534 6.95239 15.576 9.89524 15.576 10.9252",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.3047,
    y: 8.93896,
    width: 6,
    height: 8,
    fill: "#4E4E4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5705 12.6526L21.7569 8.37437L26.6159 7.89833L24.5705 12.6526Z",
    fill: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.2d295c8be839f8b762402b97de2c332a.svg";
export { ForwardRef as ReactComponent };